import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng-fe/public_method';
import Chip from 'Chip';
import styles from './index.css';
import { classNames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';

class Nav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    listView(list) {
        return list.map((item, index) => {
            return (
                <li key={index}>
                    <a href={formatUrl(item.url)} target="_blank" rel={relText}>
                        {item.title}
                    </a>
                </li>
            );
        });
    }
    render() {
        return <ul className={classNames(styles.nav, 'clearfix')}>{this.listView(this.props.content)}</ul>;
    }
}

class TopNav extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { topnav, channel } = this.props.content;

        return (
            <div className={styles.box}>
                <div className={classNames(styles.box2, 'clearfix')}>
                    <a className={styles.logo} href={formatUrl(channel[0].domain)} target="_blank" rel={relText}>
                        <img src={require('./logo.png')} alt="凤凰网公益-创新" />
                    </a>
                    <Chip id="45011" type="struct" title="导航" groupName="导航" content={topnav}>
                        <Nav />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default TopNav;
